import { useEffect } from 'react';

import { useAuth0 } from '@auth0/auth0-react';

export const Callback = () => {
  const { handleRedirectCallback, isAuthenticated } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      handleRedirectCallback();
    }
  }, [handleRedirectCallback, isAuthenticated]);

  return (
    <div>
      Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sed sit quibusdam totam illo, odio
      aperiam debitis eaque laborum magnam veniam dicta dolorem expedita accusantium fugiat,
      exercitationem, tempore quod repellendus nam!
    </div>
  );
};
